module.exports = __webpack_public_path__ + "static/media/clear_circle.2072620e.svg";